if (!customElements.get('mc-product-features')) {
  customElements.define('mc-product-features', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.info.sectionId) return;
        const source = data.html.getElementById(this.info.id)?.querySelector('mc-product-features');
        if (!source) return;
        this.dataset.variantId = source.dataset.variantId;
        if (source.dataset.profile === this.dataset.profile) { this.track.scrollLeft = 0; return; }
        this.cleanup();
        this.dataset.profile = source.dataset.profile;
        this.dataset.variantId = source.dataset.variantId;
        this.replaceChildren(...source.cloneNode(true).childNodes);
        this.setup();
      });
      this.setup();
    }
    setup() {
      this.lifecycle = new AbortController();
      const active = this.querySelector('[data-mc-features-profile]:not([hidden])');
      this.track = active.querySelector('.mc-features__track');
      this.cards = [...this.track.querySelectorAll('.mc-features__card')];
      this.dots = [...active.querySelectorAll('.mc-features__dots span')];
      this.track.scrollLeft = 0;
      this.observer = new window.MCScrollSnapDots(this.track, this.cards, this.dots, '.mc-features__card', this.lifecycle.signal);
      active.querySelectorAll('img').forEach(img => img.addEventListener('error', () => { img.hidden = true; }, { signal:this.lifecycle.signal }));
    }
    cleanup() { this.observer?.disconnect(); this.lifecycle?.abort(); }
    disconnectedCallback() { this.cleanup(); this.unsubscribe?.(); }
  });
}
